import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

const ReturnPolicy = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [])
    return (
      <Fragment>
        <BreadCrumb title={`Return Policy`} />
        <main className="privacy-policy-main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="privacy-gernal-info">
                  <h3 className="general-heading">General Returns Policy</h3>
                  <div>
                    <p>&nbsp;</p>
                    <p>
                      We want you to love your purchase. That’s why we created a
                      hassle-free returns policy. We’re here to help you out!
                    </p>
                    <p>
                      Most items can be returned within 30 days of delivery for
                      a refund or store credit. Return shipping costs may apply,
                      and the item must be in its original condition and
                      packaging to be accepted.
                    </p>
                    <p>&nbsp;</p>
                    <p>A few items cannot be returned:</p>
                    <ul>
                      <li>Clearance items</li>
                      <li>Gift cards</li>
                      <li>Customized items</li>
                      <li>
                        Items bundled at a discount like 4 for $40 (unless the
                        whole bundle is returned in original condition)&nbsp;
                      </li>
                      <li>Items marked “non-returnable” on sale page</li>
                      <li>Items you have assembled</li>
                    </ul>
                    <p>
                      Don’t worry,&nbsp;
                    {/*   <a href="https://sundialhomeproducts.com/returns-policy#damaged"> */}
                        damaged and defective
                   {/*    </a> */}
                      &nbsp;items are excluded from these exceptions.
                    </p>
                    <p>
                      In the rare case your goods are delivered damaged or
                      defective, we will work with you to find the best
                      solution.
                    </p>
                    <p>
                      Visit&nbsp;
                      <Link to={"/my-orders"}>My Orders</Link>
                      &nbsp;to start a return. For a walk-through of the returns
                      process, read our&nbsp;
                      {/* <a href="https://sundialhomeproducts.com/returns-policy#returns"> */}
                        Returns and Exchanges
                   {/*    </a> */}
                      &nbsp;article.
                    </p>
                    <p>&nbsp;</p>
                    <p>Refund Options</p>
                    <p>
                      When you return an item, you can receive store credit, or
                      have your original payment method refunded. Any associated
                      return shipping costs will be deducted from the refund
                      amount. See&nbsp;
                   {/*    <a href="https://sundialhomeproducts.com/returns-policy#refunds"> */}
                        Refunds&nbsp;
                  {/*     </a> */}
                      article for more details.
                    </p>
                    <p>&nbsp;</p>
                    <p>Special Returns Policies</p>
                    <p>Holiday Returns Policy:</p>
                    <p>
                      Items purchased between December 1<sup>st</sup>&nbsp;to
                      December 31<sup>st</sup>&nbsp;may be returned through
                      January 31<sup>st</sup>.
                    </p>
                    <p>Tile Returns Policies:</p>
                    <p>
                      E-mail as at customercare@sundialhomeproducts.com for more
                      information about our Tile Returns Policy.
                    </p>
                    <p>
                      <br />{" "}
                    </p>
                    <p>
                      <strong>Damaged or Defective Items</strong>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      It’s frustrating and we understand. For damaged or
                      defective items, return shipping is on us. We will help
                      you find the solution that works for you - you can choose
                      your preferred resolution:
                    </p>
                    <ul>
                      <li>A replacement for the item</li>
                      <li>A replacement part (eg. chair leg)</li>
                      <li>A refund</li>
                    </ul>
                    <p>Here’s how to get started:&nbsp;</p>
                    <ol>
                      <li>
                        Go to&nbsp;
                        <Link to={"/my-orders"}>My Orders</Link>
                      </li>
                      <li>
                        Choose from your preferred resolution - “Return Item” or
                        “Replace Item or Parts”
                      </li>
                      <li>Select “Damaged or Defective”</li>
                      <li>Choose your resolution</li>
                    </ol>
                    <p>
                      Return instructions will be provided for the damaged or
                      defective items. Just make sure to complete this within 30
                      days of the delivery date. We apologize for the imperfect
                      experience.&nbsp;
                    </p>
                    <p>
                      <br />{" "}
                    </p>
                    <p>
                      <strong>Refunds</strong>
                    </p>
                    <p>
                      <br />{" "}
                    </p>
                    <p>How will I receive my refund?</p>
                    <p>
                      When you return an item, you can receive store credit
                      (never expires), or have your original payment method
                      refunded. Any associated return shipping costs, if
                      applies, will be deducted from the refund amount.
                    </p>
                    <p>&nbsp;</p>
                    <p>How long does it take to receive my refund?</p>
                    <p>
                      For store credit and gift card refunds, we will credit
                      your account within 1-2 business days after we receive the
                      returned item(s).
                    </p>
                    <p>
                      For credit card refunds, we will issue the refund within
                      1-2 business days after we receive the returned item(s).
                      Banks typically take 3-5 days to process your refund.
                    </p>
                    <p>
                      For all other refunds, please allow up to 2 weeks to
                      process the return and issue your refund.
                    </p>
                    <p>
                      You can check the status of your refund via the&nbsp;
                      <Link to={"/my-orders"}>My Orders</Link>
                      &nbsp;page.
                    </p>
                    <p>&nbsp;</p>
                    <p>Can I change my refund method?</p>
                    <p>
                      Changes to your refund method can be processed via “change
                      my refund method” on the&nbsp;
                      <Link to={"/my-orders"}>My Orders</Link>
                      &nbsp;page. This can only be done before you have returned
                      the item.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Returns and Exchanges</strong>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      If your item is damaged or missing parts, don’t worry.
                      See&nbsp;
                      <a href="https://sundialhomeproducts.com/returns-policy#damaged">
                        Damaged or Defective Items
                      </a>
                      &nbsp;for more information.
                    </p>
                    <p>&nbsp;</p>
                    <p>Returns</p>
                    <p>
                      Most of our items can be returned within 30 days of
                      delivery however some items are not eligible for returns.
                      Some products have a modified returns policy. For full
                      details, read our&nbsp;
             {/*          <a href="https://sundialhomeproducts.com/returns-policy#general"> */}
                        Returns Policy
                   {/*    </a> */}
                      <u>.</u>
                    </p>
                    <p>
                      Our policy is easy and hassle-free. You can take care of
                      the entire process online!
                    </p>
                    <ul>
                      <li>
                        Go to&nbsp;
                        <Link to={"/my-orders"}>My Orders</Link>
                        &nbsp;and select “return item”
                      </li>
                      <li>Choose your return and refund method.&nbsp;</li>
                      <li>
                        Check for a return confirmation email. We’ll refund you
                        once the item(s) get sent back
                      </li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                      Returns Where Store Credit or Cash Back Have Been Gained
                    </p>
                    <p>
                      If you return an item where store credit or cash back have
                      been earned, we will deduct the rewarded store credit or
                      cash back that has been used from your preferred refund
                      method.&nbsp;
                    </p>
                    <p>Return Shipping:&nbsp;</p>
                    <p>
                      A return shipping cost will be deducted from your refund
                      if applicable.
                    </p>
                    <p>Returns via UPS or FedEx:</p>
                    <p>
                      Your return confirmation email will include a shipping
                      label. Print this shipping label and bring the package to
                      a nearby drop-off location.
                    </p>
                    <p>
                      For special carriers (large, heavy, or fragile
                      items):&nbsp;
                    </p>
                    <p>
                      Generate your return in the same way listed above.
                      However, instead of printing a shipping label, we will
                      have the carrier pick up the package at your convenience.
                    </p>
                    <p>&nbsp;</p>
                    <p>Refunds</p>
                    <p>
                      When returning an item, you can choose between store
                      credit or receive a refund to your original payment
                      method. For more details, see&nbsp;
                      {/* <a href="https://sundialhomeproducts.com/admin/returns-policy#refunds"> */}
                        Refunds
                     {/*  </a> */}
                      .
                    </p>
                    <p>&nbsp;</p>
                    <p>Canceling Returns</p>
                    <p>
                      If you’ve already filled out a return form but changed
                      your mind, don’t worry! Cancel the return request from
                      the&nbsp;
                      <Link to={"/my-orders"}>My Orders</Link>
                      &nbsp;page.
                    </p>
                    <p>&nbsp;</p>
                    <p>Exchanges&nbsp;</p>
                    <p>
                      We are happy to help you find the products you need! If
                      you would like to exchange an item for another color,
                      size, or different product altogether, there are two ways
                      to exchange an item, depending on your preference.&nbsp;
                    </p>
                    <ul>
                      <li>
                        Before returning: To receive the new item sooner, you
                        can place an order for the new item before you return
                        the old item. We will credit your account or original
                        payment method once we have received the return. Note:
                        you cannot use your store credit until we have credited
                        your account.
                      </li>
                    </ul>
                    <ul>
                      <li>
                        After the return: Follow the same steps as a normal
                        return. When you receive your refund, use your refund
                        credit to place a new order.&nbsp;
                      </li>
                    </ul>
                    <p>
                      A refund shipping cost will still apply for all exchanges
                      and will be deducted from the refund amount.&nbsp;
                    </p>
                    <p>
                      <br />{" "}
                    </p>
                    <p>
                      <strong>Received the Wrong Item&nbsp;</strong>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      If we sent you the wrong item, we want to fix that ASAP!
                    </p>
                    <p>To get the right item:</p>
                    <ol>
                      <li>
                        Go to&nbsp;
                        <Link to={"/my-orders"}>My Orders</Link>
                      </li>
                      <li>Select “replace item or parts”</li>
                      <li>Choose “not what I ordered”</li>
                      <li>Pick your resolution (refund, or replacement)</li>
                      <li>
                        You will receive and email with return instructions from
                        us
                      </li>
                    </ol>
                    <p>
                      We will send information to the supplier to make sure this
                      doesn’t happen again. Make sure to complete this process
                      within 30 days of the delivery date.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Missing or Incomplete Orders</strong>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      Most missing orders are found within a couple days of
                      expected delivery. If your order status says delivered but
                      you haven’t received your package, follow these steps:
                    </p>
                    <ul>
                      <li>Confirm your shipping address</li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp; -&nbsp;&nbsp;&nbsp;&nbsp;Your shipping address is
                      listed under “Deliver to” on the&nbsp;
                      <Link to={"/my-orders"}>My Orders</Link>
                      &nbsp;page
                    </p>
                    <ul>
                      <li>
                        Check your mailbox, or anywhere else you receive mail
                      </li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp; -&nbsp;&nbsp;&nbsp;&nbsp;If the item you shipped is
                      small enough, some carriers may place it in your mailbox
                    </p>
                    <ul>
                      <li>Check the various entrances of your home&nbsp;</li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp; -&nbsp;&nbsp;&nbsp;&nbsp;In an effort to protect
                      from theft, the driver may have left your package in a
                      safer place. Be sure to check your front porch, garage
                      area, back porch, around your grill, and even
                      bushes.&nbsp;
                    </p>
                    <ul>
                      <li>
                        Check with others at your address or with neighbors
                      </li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp; -&nbsp;&nbsp;&nbsp;&nbsp;They might have accepted
                      the package to protect it from theft or bad weather
                      conditions
                    </p>
                    <ul>
                      <li>Check for a notice of attempted delivery</li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp; This notice will have more
                      information on details and recovering your package&nbsp;
                    </p>
                    <ul>
                      <li>Give it a little more time</li>
                    </ul>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp; -&nbsp;&nbsp;&nbsp;&nbsp;Some carriers will scan
                      items as delivered prior to arrival. Wait 2 days to
                      account for this. Thanks for your patience!
                    </p>
                    <p>
                      If it has already been 2 days past your scheduled delivery
                      and your package is still missing, you can follow these
                      steps:
                    </p>
                    <p>&nbsp;</p>
                    <p>Contact the carrier</p>
                    <ul>
                      <li>
                        Use your tracking number to start a claim with the
                        carrier (FedEx, UPS, etc.)
                      </li>
                      <li>To contact FedEx, call 1-800-463-3339</li>
                      <li>For UPS, submit a claim or call 1-866-742-5877</li>
                    </ul>
                    <p>
                      <br />{" "}
                    </p>
                    <p>Cancelling an Email Subscription</p>
                    <p>
                      You can unsubscribe, or choose to receive fewer email at
                      any time. For more details, check out&nbsp;
                      <Link to={"/newsletter"}>email subscriptions</Link>
                      .&nbsp;
                    </p>
                    <p>
                      <br />{" "}
                    </p>
                    <p>
                      <strong>Changing Account Information</strong>
                    </p>
                    <p>
                      <strong>
                        <br /> <br />{" "}
                      </strong>
                    </p>
                    <p>
                      Visit&nbsp;
                      <Link to={"/dashboard"}>My Account</Link>
                        My Account
                  
                      &nbsp;to update your information. From there you can
                      change your:
                    </p>
                    <ul>
                      <li>Password</li>
                      <li>Email address</li>
                      <li>Shipping address</li>
                      <li>Credit cards</li>
                      <li>Phone number for text notifications</li>
                      <li>Membership plan</li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>
                      <strong>
                        Cash-back, Promo Codes, Store Credit, and Gift Cards
                      </strong>
                    </p>
                    <p>
                      <strong>
                        <br /> <br />{" "}
                      </strong>
                    </p>
                    <p>Cash Back</p>
                    <p>
                      We are changing the definition of cash back. We believe
                      that cash back should be just that, cash back. Members are
                      eligible to cash out on their cash back balance. Cash outs
                      can be redeemed at any time through the&nbsp;
                      <Link to={"/dashboard"}>My Account</Link>
                      &nbsp;page. Simply select the amount you want to cash out
                      on and confirm via an email verification which we will
                      send to you. &nbsp;Your cash back will be placed into your
                      bank account! (Sundial members receive up to 5% cash back
                      on most purchases)
                    </p>
                    <p>&nbsp;</p>
                    <p>Promo Codes</p>
                    <p>
                      Promo codes can be applied to your order during checkout.
                      Promo codes are applicable to most products, but there may
                      be some restrictions. Restrictions may include time frame,
                      type of product, or a specific brand. Product eligibility
                      details are listed along with your promo code.
                    </p>
                    <p>&nbsp;</p>
                    <p>Store Credit</p>
                    <p>
                      Store credit never expires! Free and paid members earn
                      store credit on each purchase and may receive credit from
                      us as special promotions. Store credit can be earned on
                      most products, and can be given as a refund, or as a
                      discount on an existing order. Store credit cannot be
                      cashed out. Your store credit will appear on the top right
                      corner of your screen, when you log in, and can also be
                      seen in your account details in&nbsp;
                      <Link to={"/dashboard"}>My Account</Link>
                      .
                    </p>
                    <p>&nbsp;</p>
                    <p>Gift Cards</p>
                    <p>
                      To apply a gift card, visit the&nbsp;
                      <u>Redeem a gift card</u>&nbsp;page and enter your gift
                      card code. When you redeem your gift card, the entire
                      amount will be added to your account as store credit. Gift
                      cards never expire. Just apply the credit amount at
                      checkout when you are ready to use it! Visit&nbsp;
                      <Link to={"/dashboard"}>My Account</Link>
                      &nbsp;to see your remaining balance.
                    </p>
                    <p>
                      To learn more about gift cards, visit our&nbsp;
                   {/*    <a href="https://sundialhomeproducts.com/index.php?route=account/voucher"> */}
                        Sundial Gift Cards
                      {/* </a> */}
                      &nbsp;page.&nbsp;
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </Fragment>
    );
  }

export default ReturnPolicy;
